import { render } from "./HomeOwner.vue?vue&type=template&id=0b42d8bf&scoped=true"
import script from "./HomeOwner.vue?vue&type=script&lang=js"
export * from "./HomeOwner.vue?vue&type=script&lang=js"

import "./HomeOwner.vue?vue&type=style&index=0&id=0b42d8bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b42d8bf"]])

export default __exports__